// Quality route (/$region/quality, Operator): typed document, tab, flag and priority search params; the screen is QualityPage.
import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { z } from "zod";

import { zQualityFlag } from "@/api/__generated__/zod.gen";
import { optionalString, enumWithDefault, optionalList, listWithDefault } from "@/app/search";
import { RestrictedRoute } from "@/app/shell/RouteStates";
import { QualityPage } from "@/features/operations/QualityPage";

const searchSchema = z.object({
  doc: optionalString(),
  tab: enumWithDefault(["overview", "requirements", "clauses", "completeness", "integrity"], "overview"),
  flag: optionalList(zQualityFlag),
  priority: listWithDefault(z.string(), ["P1"]),
});

const searchDefaults = { tab: "overview", priority: ["P1"] } satisfies Partial<z.output<typeof searchSchema>>;

export const Route = createFileRoute("/_app/$region/quality")({
  validateSearch: searchSchema,
  search: { middlewares: [stripSearchParams(searchDefaults)] },
  staticData: { crumb: "Quality" },
  component: QualityRoute,
});

function QualityRoute() {
  return (
    <RestrictedRoute level="O" description="The extraction quality checks are for operators.">
      <QualityPage />
    </RestrictedRoute>
  );
}
